// extracted by mini-css-extract-plugin
export default {"container":"RatingSelector_container__6YUjU","circle":"RatingSelector_circle__HHabj","circle-active":"RatingSelector_circle-active__slNfi"};